import React, { createContext, useEffect } from "react";
import { Routes, Route, useParams } from "react-router-dom";
import Layout from "./app/components/Layout";
import RequireAuth from "./app/auth/RequireAuth";
import LoginPage from "./app/pages/LoginPage";
import uiManager from './config/ui.js';
import { UiManagerContext } from './config/ui.js';
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <div className="App">
      <UiManagerContext.Provider value={uiManager}>
        <Routes>
          <Route path="/" element={<Layout />}>
            {/* public routes */}
            <Route index element={<LoginPage />} />

            {/* protected routes */}
            <Route element={<RequireAuth />}>
              { uiManager.uiRoutes.map((uiRoute, inx) => {
                return <Route
                  key={inx}
                  uiManager={uiManager}
                  path={uiRoute.path}
                  element={uiRoute.uiPage.pageComponent}
                />
              }) }
            </Route>
          </Route>
        </Routes>
      </UiManagerContext.Provider>
    </div>
  );
}

export default App;
